import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPieOutline$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPieOutline extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '767498c65b201759a22c6133d087e7d3951ac5d3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ba013d3d78572010cbb2eec2a2e81667871691bf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '103d3329da4add0c6c4190006df6cd7c2e64a160', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 2q.77.001 1.5.14A8.01 8.01 0 0 1 20 10h-7.5a.5.5 0 0 1-.5-.5zm6.326 6.5A6.51 6.51 0 0 0 13.5 3.674V8.5zM10 18.5a6.5 6.5 0 0 0 6.326-5H10.5a2 2 0 0 1-2-2V5.674A6.5 6.5 0 0 0 10 18.5M8.5 4.14A8 8 0 1 0 18 12h-7.5a.5.5 0 0 1-.5-.5V4q-.77.001-1.5.14", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pie-outline", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pie-outline"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pie-outline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPieOutline$1);
            }
            break;
    } });
}

const CosmosIconPieOutline = CosmosIconPieOutline$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPieOutline, defineCustomElement };
